import HttpAdapter, { ApiVersion, HttpMethod } from "../../utils/http-adaper";

const AdminService = {
  getAllOperators: async () =>
    await HttpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: "admin/operators",
      authneticated: true,
    }),
  getOperatorStat: async ({ operatorId, from, to }) =>
    await HttpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: "admin/operator_stats",
      authneticated: true,
      queryParams: { operatorId, from, to },
    }),
  getOperatorDailyStats: async ({ operatorId, from, to }) =>
    await HttpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: "admin/operator_daily_stats",
      authneticated: true,
      queryParams: { operatorId, from, to },
    }),
  getPostsByStatus: async ({ status }) => {
    return await HttpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: `admin/posts`,
      authneticated: true,
      queryParams: { status },
    });
  },
};

export default AdminService;
